var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundOverlap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 844,
    height: 844,
    viewBox: "0 0 844 844",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.66113,
    y: 421.801,
    width: 198.369,
    height: 198.369,
    transform: "rotate(-45 1.66113 421.801)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.198,
    y: 421.8,
    width: 198.369,
    height: 198.369,
    transform: "rotate(-45 282.198 421.8)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.196,
    y: 702.336,
    width: 198.369,
    height: 198.369,
    transform: "rotate(-45 282.196 702.336)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.194,
    y: 141.268,
    width: 198.369,
    height: 198.369,
    transform: "rotate(-45 282.194 141.268)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.729,
    y: 421.803,
    width: 198.369,
    height: 198.369,
    transform: "rotate(-45 562.729 421.803)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.097 490.903L353.365 631.171",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.457 209.541L521.932 237.016C546.292 261.376 546.292 300.871 521.932 325.231L494.044 353.12",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.231,
    cy: 421.801,
    r: 11.7262,
    transform: "rotate(-45 282.231 421.801)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634.763,
    cy: 349.8,
    r: 11.7262,
    transform: "rotate(-45 634.763 349.8)",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundOverlap);
export default __webpack_public_path__ + "static/media/background-overlap.6d1a024c.svg";
export { ForwardRef as ReactComponent };